var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute inset overflow-hidden"},[_c('div',{attrs:{"id":"hex-wrapper"}},[_c('div',{staticClass:"hex-spot"})])])
}]

export { render, staticRenderFns }